class TaskRunner {
  static async parallel(tasks) {
    await Promise.all(tasks.map(fn => fn().catch(console.error)));
  }
  static async sequential(tasks) {
    for (const fn of tasks) {
      try { await fn(); }
      catch(e) { console.error(e); }
    }
  }
}
export default TaskRunner
